import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
declare var html2pdf: any;
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { LoggingService } from 'src/app/services/consoleLogs';
import { Module } from 'src/app/models/module.model';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-certificate',
  standalone: true,
  templateUrl: './certificate.component.html',
  styleUrl: './certificate.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CertificateComponent implements OnInit {
  @Input() certificateDate: string='';
  @Input() moduleTitle: string = '';
  name: string = '';
  isLoading: boolean = true; // Variable to track loading state
  itemId: string | null = null;
  moduleId! :string ;
  @Input() certificateId!:string;
  type: string = ''; 
  private encryptionKey =
    '9237d2499e6b7e07ad0a7f4bfa4c7918cbe4f2ac9830ed52ed8c90f298c58e5d';
  certificateData: any;
  contentAccess!: string;
  constructor(
    private baseServicesService: BaseServicesService,
    private loggingService: LoggingService,
     private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.subscribeToContentAccess();
    this.route.queryParams.subscribe((params) => {
      const encryptedId = params['id'];
      if (encryptedId) {
        this.moduleId = this.decryptModuleId(encryptedId);
        this.loggingService.log('Module ID:', this.moduleId);
      
      }
    });
    this.baseServicesService.getProfile().subscribe(
      (response) => {
        this.isLoading = false; // Set loading to false once data is fetched
        if (response && response.data && response.data.name) {
          this.name = response.data.name;
          this.loggingService.log('this.name', this.name);
        }
      },
      (error) => {
        this.isLoading = false;
        this.loggingService.error('Error fetching profile:', error);
      }
    );
    this.subscribeToItemId();
    this.route.queryParams.subscribe((params) => {
      const encryptedId = params['id'];
      if (encryptedId) {
        this.moduleId = this.decryptModuleId(encryptedId);
        this.loggingService.log('Module ID:', this.moduleId);
       
      }
    });
   
  }
  subscribeToItemId(): void {
    this.baseServicesService.itemId$.subscribe((itemId) => {
      this.itemId = itemId;
      this.loggingService.log('Received itemId:', this.itemId); // You can use the itemId here

      // Once itemId is received, fetch the certificate data
      if (this.itemId) {
        const moduleId = this.moduleId; // Replace with actual moduleId
        this.fetchCertificate(moduleId, this.itemId);
      }
    });
  }

  fetchCertificate(moduleId: string, certificateId: string): void {
    this.loggingService.log('Calling getCertificate with:', {
      moduleId,
      certificateId,
      type: this.type,
      contentAccess: this.contentAccess,
    });
    this.type = 'view'; 
    this.baseServicesService.getCertificate(moduleId, certificateId, this.type , this.contentAccess).subscribe(
      (response) => {
        this.loggingService.log('Certificate data:', response);
        this.certificateData = response; // Store the response
      },
      (error) => {
        this.loggingService.error('Error fetching certificate:', error);
      }
    );
  }

  private decryptModuleId(encryptedId: string): string {
      const bytes = CryptoJS.AES.decrypt(encryptedId, this.encryptionKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    }

    private subscribeToContentAccess(): void {
      this.baseServicesService.contentAccess$.subscribe((contentAccess) => {
        this.contentAccess = contentAccess;
        this.loggingService.log('Received contentAccess00001:', this.contentAccess);
      });
    }

  generatePdf() {
    const iframe = document.getElementById(
      'certificateIframe'
    ) as HTMLIFrameElement;
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      const doc = new jsPDF();
      doc.html(iframeDocument.body, {
        callback: (doc) => {
          doc.save('certificate.pdf'); // Save the generated PDF
        },
        x: 10,
        y: 10,
      });
    }
  }
  downloadCertificateSoon(): void {
    this.loggingService.log("Coming Soon");
  
    // Show SweetAlert2 message
    Swal.fire({
      title: 'Coming Soon!',
      text: 'This feature will be available soon. Stay tuned!',
      icon: 'info',
      confirmButtonText: 'OK'
    });
  }

  
  downloadCertificate(moduleId: string, certificateId: string) {
    this.type = 'download'; 
    this.baseServicesService.getCertificate(moduleId, certificateId, this.type , this.contentAccess).subscribe(
      (response) => {
        this.loggingService.log('Certificate data:', response);
        this.certificateData = response; // Store the response
      },
      (error) => {
        this.loggingService.error('Error fetching certificate:', error);
      }
    );
    const container = document.getElementById('certificateContainer');
    if (!container) {
      this.loggingService.error('Certificate container not found!');
      return;
    }
  
    const pdf = new jsPDF('l', 'mm', 'a4'); // Landscape A4
    const pdfWidth = 297; // A4 width in mm (landscape)
    const pdfHeight = 210; // A4 height in mm (landscape)
  
    // Temporarily remove margins and padding
    const originalStyle = container.getAttribute('style') || '';
    container.setAttribute('style', `${originalStyle}; margin: 0; padding: 0;`);
  
    html2canvas(container, {
      scale: 4, // Higher scale for better resolution
      useCORS: true, // Handle cross-origin images
      allowTaint: true, // Allow tainted images
      scrollX: 0, // Ensure no horizontal scroll
      scrollY: 0, // Ensure no vertical scroll
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data
  
        // Calculate the height of the canvas image for the PDF dimensions
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const aspectRatio = canvasWidth / canvasHeight;
  
        let imgWidth = pdfWidth;
        let imgHeight = pdfHeight;
  
        // Adjust the dimensions to fit the A4 page completely without cropping
        if (aspectRatio > pdfWidth / pdfHeight) {
          imgWidth = pdfWidth;
          imgHeight = pdfWidth / aspectRatio;
        } else {
          imgHeight = pdfHeight;
          imgWidth = pdfHeight * aspectRatio;
        }
  
        // Center the image on the PDF page
        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;
  
        // Add the image to the PDF
        pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);
  
        // Use moduleTitle as the filename
        const fileName = this.moduleTitle ? `${this.moduleTitle}.pdf` : 'certificate.pdf';
        pdf.save(fileName);
      })
      .catch((error) => {
        this.loggingService.error('Error generating PDF:', error);
      })
      .finally(() => {
        // Restore original styles after rendering
        container.setAttribute('style', originalStyle);
      });
  }
  
}
